var mixin = {
  computed: {
    tableData() {
      if (!this.apiPricingResponse) return null;

      var data = this.apiPricingResponse;

      return {
        labels: data.data_table.pricing_price_table_data_set_dto[0].data.map(
          d => this.moment(d.key).format("YYYY-MM-DD")
        ),
        datasets: data.data_table.pricing_price_table_data_set_dto.map(dto => {
          return {
            label: dto.label.toLowerCase(),
            is_editable: dto.editable,
            data: dto.data.map(d => d.value),
            is_hiddeable: dto.is_hiddeable
          };
        })
      };
    }
  }
};

export default mixin;
